module.exports = {
      id: "sun-usage",
      viewBox: "0 0 512 512",
      url: "/" + "sprite-79b777a110ad18271a4fc79289e4208e.svg#sun",
      toString: function () {
        return this.url;
      }
    }